module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic-BETA.6ec9551d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ThinItalic-BETA.woff
// module id = 709
// module chunks = 21